import axios from "./httpClient";
import { ApiType } from "./Types";
import { getUrl } from "./getURL";
import { ErrorMessages, TMasterSearchParameter } from "../constants";
import { IMaterUser } from "../models/user";
import { throwApiError } from "./apiError";

/**
 * GET API call using Axios
 * @param cancelToken - Token to cancel multiple requests
 * @returns - Array of Terminal List of type string[]
 */

export const getFilterMasterUser = async (params: TMasterSearchParameter): Promise<IMaterUser[]> => {
  try {
    const response = await axios.get(getUrl(ApiType.OVERAGE_FILTER_MASTER_USER), { params });
    return response?.data?.data ?? [];
  } catch (error) {
    return throwApiError(error, ErrorMessages.terminalAPIError, { badRequestOrder: "errorsFirst" });
  }
};
